import { createContext, useContext, useState } from 'react'

import { UploadTradesDialog } from '@/pages/trading/dialogs/UploadTradesDialog'
import { useDownloadTradeTemplateMutation } from '@/react-query/mutations/trades'

type TradeAction = {
  type: 'upload-trades'
  params: undefined
}

// type GetActionParams<TType extends TradeAction['type']> = Extract<TradeAction, { type: TType }>['params']

const useCreateTradeActionsContext = () => {
  const [actionState, setActionState] = useState<TradeAction | null>(null)
  const downloadTemplateMutation = useDownloadTradeTemplateMutation()

  const actions = {
    uploadTrades: () => {
      setActionState({ type: 'upload-trades', params: undefined })
    },
    downloadTemplate: () => {
      downloadTemplateMutation.mutateAsync()
    },
    close: () => setActionState(null),
  }

  return {
    actionState,
    ...actions,
  }
}

type TradeActionsContext = ReturnType<typeof useCreateTradeActionsContext>

const tradeActionsContext = createContext<TradeActionsContext | null>(null)

export const useTradeActions = () => {
  const context = useContext(tradeActionsContext)
  if (!context) {
    throw new Error('TradeActionsContext must be used within a <TradeActionsProvider/>.')
  }
  return context
}

interface TradeActionsProviderProps {
  children?: React.ReactNode | ((ctx: TradeActionsContext) => React.ReactNode)
}

export const TradeActionsProvider: React.FC<TradeActionsProviderProps> = ({ children }) => {
  const context = useCreateTradeActionsContext()
  const state = context.actionState

  const dialogProps = {
    open: true,
    onClose: context.close,
  }

  return (
    <tradeActionsContext.Provider value={context}>
      {typeof children === 'function' ? children(context) : children}
      {state?.type === 'upload-trades' && <UploadTradesDialog {...dialogProps} />}
    </tradeActionsContext.Provider>
  )
}
